"use client"

import { useState, useEffect } from "react"
import Dashboard from "../../../layout/Dashboard"
import { FiscalForm } from "../Forms"
import { Api } from "../../../api/Assinafy"
import { PageLoader } from "../../../components"
import "./styles.scss"

const FiscalData = () => {
  const [selectedCheckbox, setSelectedCheckbox] = useState(true)
  const [customerData, setCustomerData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const isCPF = (taxpayerId) => {
    if (!taxpayerId) return true
    const cleanId = taxpayerId.replace(/\D/g, "")
    return cleanId.length === 11
  }

  const formatCPF = (cpf) => {
    if (!cpf) return ""
    const cleanCPF = cpf.replace(/\D/g, "")
    return cleanCPF.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4")
  }

  const formatCNPJ = (cnpj) => {
    if (!cnpj) return ""
    const cleanCNPJ = cnpj.replace(/\D/g, "")
    return cleanCNPJ.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5")
  }

  const formatCEP = (cep) => {
    if (!cep) return ""
    const cleanCEP = cep.replace(/\D/g, "")
    return cleanCEP.replace(/(\d{5})(\d{3})/, "$1-$2")
  }
  useEffect(() => {
    const fetchCustomerData = async () => {
      try {
        setLoading(true)
        setError(null)

        const response = await Api("customer/view")()

        if (response && response.status === 200 && response.data) {
          const data = response.data.data
          setCustomerData(data)

          const isPF = isCPF(data.taxpayer_id)
          setSelectedCheckbox(isPF)
        } else {
          throw new Error("Erro ao buscar dados do cliente")
        }
      } catch (err) {
        console.error("Erro ao buscar dados do customer:", err)
        setError(err.message || "Erro ao carregar dados fiscais")
      } finally {
        setLoading(false)
      }
    }

    fetchCustomerData()
  }, [])

  const getFormDefaults = () => {
    if (!customerData) return {}

    const isPF = isCPF(customerData.taxpayer_id)

    return {
      name: customerData.name || "",
      cpf: isPF ? formatCPF(customerData.taxpayer_id) : "",
      cnpj: !isPF ? formatCNPJ(customerData.taxpayer_id) : "",
      cep: formatCEP(customerData.address?.postal_code) || "",
      city: customerData.address?.city || "",
      state: customerData.address?.state || "",
      address: customerData.address?.line1
        ? `${customerData.address.line1}${customerData.address.house_number ? ", " + customerData.address.house_number : ""}${customerData.address.line2 ? ", " + customerData.address.line2 : ""}`
        : "",
      neighborhood: customerData.address?.neighborhood || "",
      email: customerData.email || "",
      phone: customerData.phone_number || "",
    }
  }

  if (loading) {
    return <PageLoader />
  }

  if (error) {
    return (
      <Dashboard.Content style={{ maxWidth: "608px" }}>
        <Dashboard.Header returnButton={true} title="Dados fiscais" className="d-flex reverse-row" />
        <div className="alert alert-danger">
          <p>Erro ao carregar dados fiscais: {error}</p>
          <button className="btn btn-primary" onClick={() => window.location.reload()}>
            Tentar novamente
          </button>
        </div>
      </Dashboard.Content>
    )
  }

  const defaults = getFormDefaults()

  return (
    <>
      <Dashboard.Content style={{ maxWidth: "608px" }}>
        <Dashboard.Header returnButton={true} title="Dados fiscais" className="d-flex reverse-row" />
        <p className="fiscalData-info">Informações utilizadas para emitir a fatura e a Nota Fiscal</p>
        <div className="fiscalData-switch-wrapper">
          <label className="fiscalData-switch">
            <input checked={selectedCheckbox} onChange={() => setSelectedCheckbox(true)} type="checkbox" />
            <div>Pessoa Física</div>
          </label>
          <label className="fiscalData-switch">
            <input checked={!selectedCheckbox} onChange={() => setSelectedCheckbox(false)} type="checkbox" />
            <div>Pessoa Jurídica</div>
          </label>
        </div>
        <FiscalForm cpf={selectedCheckbox} defaults={defaults} customerData={customerData} />
      </Dashboard.Content>
    </>
  )
}

export default FiscalData
